module.exports = __webpack_public_path__ + "img/4.e04149d3.jpeg";